import React, { useState, useEffect } from "react";
import {
  FaTimes,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaArrowUp,
  FaWhatsapp,
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { FaMessage } from "react-icons/fa6";


const HomeButton = () => {
  const [isArrowVisible, setIsArrowVisible] = useState(false); // Only for scroll-to-top arrow
  const [showIcons, setShowIcons] = useState(false);

  // Control arrow visibility based on scroll position
  const toggleArrowVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsArrowVisible(true);
    } else {
      setIsArrowVisible(false);
    }
  };

  const handleButtonClick = () => {
    setShowIcons((prev) => !prev);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleArrowVisibility);
    return () => {
      window.removeEventListener("scroll", toggleArrowVisibility);
    };
  }, []);

  const iconVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 10 },
  };

  return (

    <div className="fixed md:bottom-10 md:right-10 right-5 bottom-6 transition-opacity duration-300 z-50 flex flex-col items-center gap-2  ">
      {/* Social Media Icons and Scroll-to-Top Button */}
      <AnimatePresence >
        {showIcons && (
          <motion.div
            className="flex flex-col items-center gap-3 mb-2 "
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={{
              visible: { transition: { staggerChildren: 0.1 } },
              hidden: {
                transition: { staggerChildren: 0.1, staggerDirection: -1 },
              },
            }}
          >
            {/* Scroll to Top Button with Animation */}
            {isArrowVisible && (
              <motion.button
                onClick={scrollToTop}
                className="flex items-center justify-center bg-gray-500 text-white rounded-full p-3 h-10 w-10 mb-2 hover:bg-gray-700 transition-colors"
                variants={iconVariants}
              >
                <FaArrowUp className="text-xl" />
              </motion.button>
            )}

            <motion.a
              href="https://www.facebook.com/aruba.creative.09"
              target="_blank"
              rel="noopener noreferrer"
              className="text-4xl text-blue-600 hover:text-blue-800"
              variants={iconVariants}
            >
              <FaFacebook />
            </motion.a>
            <motion.a
              href="https://wa.me/message/UXA23MPLONOAP1"
              target="_blank"
              rel="noopener noreferrer"
              className="text-4xl text-green-500 hover:text-green-600"
              variants={iconVariants}
              >
              <FaWhatsapp />
            </motion.a>
            <motion.a
              href="https://www.instagram.com/aruba.creative?igsh=MW8ya3E0aW51aGpkcg=="
              target="_blank"
              rel="noopener noreferrer"
              className="text-4xl text-pink-500 hover:text-pink-700"
              variants={iconVariants}
            >
              <FaInstagram />
            </motion.a>
            <motion.a
              href="https://www.linkedin.com/company/aruba-creative-09/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              className="text-4xl text-blue-700 hover:text-blue-900"
              variants={iconVariants}
            >
              <FaLinkedin />
            </motion.a>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Button */}
      <div
        onClick={handleButtonClick}
        className="flex items-center justify-center bg-slate-700 text-white rounded-full p-3 h-14 w-14 cursor-pointer "
      >
        {showIcons ? (
          <FaTimes className="text-2xl " />
        ) : (
          <FaMessage   className="text-2xl" />
        )}
      </div>
    </div>
  );
};

export default HomeButton;
